import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from './header.service';

import RoutesserviceService from './routesservice.service';

@Injectable({
  providedIn: 'root'
})
export class AdmindasboardservicesService {

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }


  async getuserdetail() {
    return this.httpClient
      .get(this.Customeroutes.userdetail(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }



  async getemployeesDetail() {
    return this.httpClient
      .get(this.Customeroutes.employeesdetail(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getemployeesevaluation() {
    return this.httpClient
      .get(this.Customeroutes.employeesevaluation(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }
  async upcomingevent() {
    return this.httpClient
      .get(this.Customeroutes.getevent(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {

          if (data.success == true) {

            //if login is true the store it into local storage
            // localStorage.setItem('token', data.data.token);
            return data;
            // this.showSpinner=false;
          }
        }
        return data;
      });
  }



  async getLeaveslog(duration :any) {
    const postBody = {
      duration: duration,
    };
      return this.httpClient
        .post(this.Customeroutes.getLeaveslog(), postBody, {
          headers: this.HeaderService.getHeaderWithToken(
            localStorage.getItem('token')
          ),
        })
        .pipe()
        .toPromise()
        .then((data: any) => {
          if (data.success == true) {
            return data;
          }
          return data;
        });
    }



    async headCounts() {
        return this.httpClient
          .post(this.Customeroutes.headCounts(), '', {
            headers: this.HeaderService.getHeaderWithToken(
              localStorage.getItem('token')
            ),
          })
          .pipe()
          .toPromise()
          .then((data: any) => {
            if (data.success == true) {
              return data;
            }
            return data;
          });
      }



      async requestData(request_type :any) {
        const postBody = {
          request_type: request_type,
        };
          return this.httpClient
            .post(this.Customeroutes.requestData(), postBody, {
              headers: this.HeaderService.getHeaderWithToken(
                localStorage.getItem('token')
              ),
            })
            .pipe()
            .toPromise()
            .then((data: any) => {
              if (data.success == true) {
                return data;
              }
              return data;
            });
        }

}

